module.exports = __webpack_public_path__ + "static/img/BO@2x.ce781aa3.jpg";